import { Modal, Typography } from "@sunrun/experience-ui-components";
import styled from "@emotion/styled/macro";
import type { ContractReviewMessage } from "../../../../amplify/backend/function/OfferExpCheckout/ts/public/types";
import { NON_BLOCKING_COPY } from "../../../constants/contractReviewNonBlockingCopy";
import { ContractReviewIssuesList } from "components/atoms/ContractReviewIssuesList";

type CheckoutContractReviewIssuesModalProps = {
  open: boolean;
  messages: ContractReviewMessage[];
  onAcknowledge: () => void;
};

const CheckoutContractReviewIssuesModal = ({
  open,
  messages,
  onAcknowledge,
}: CheckoutContractReviewIssuesModalProps) => {
  if (!open || messages.length === 0) {
    return null;
  }

  const count = messages.length;
  const title = count === 1 ? "1 issue found" : `${count} issues found`;

  return (
    <Modal
      testId="checkout-contract-review-issues-modal"
      type="warning"
      title={title}
      onClose={onAcknowledge}
      primaryButton={{
        text: "Acknowledge",
        onClick: onAcknowledge,
      }}
    >
      <BodyStack>
        <Typography color="text.secondary">{NON_BLOCKING_COPY}</Typography>
        <ContractReviewIssuesList messages={messages} />
      </BodyStack>
    </Modal>
  );
};

const BodyStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export { CheckoutContractReviewIssuesModal };
export type { CheckoutContractReviewIssuesModalProps };
